module.exports = __webpack_public_path__ + "ethereum-classic-etc-logo.svg?9d4534ae68dc2efc7ee6f7186e3c8b6b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ethereum-classic-etc-logo.svg
// module id = 1107
// module chunks = 2